import React from "react";

export default function AlertComponent(props) {
  return (
    <div className="alert-container-3" style={{fontSize:'10px'}}>
      {props.text.includes("Alerts:") ? (
        <>
          {/* <div className="light"></div> */}
          <div className="title-alert-red-3" style={{fontSize:'10px',lineHeight:"10px"}}>{props.text}</div>
        </>
      ) : props.text.includes("Allergies:") ? (
        <>
          {/* <div className="light-yellow"></div> */}
          <div className="title-alert-yellow" style={{fontSize:'10px',lineHeight:"10px"}}>{props.text}</div>
        </>
      ) : (
        <>
          {/* <div className="light-blue"></div> */}
          <div className="title-alert-blue" style={{fontSize:'10px',lineHeight:"10px"}}>{props.text}</div>
        </>
      )}
    </div>
  );
}
